import Typography from '@mui/material/Typography';
import { memo, ReactNode } from 'react';

interface Props {
  isEmpty: boolean;
  emptyPlaceholder: string | ReactNode;
}

export const TableEmptyPlaceholder = memo<Props>(
  ({ isEmpty, emptyPlaceholder }) => {
    if (!isEmpty) return null;

    if (typeof emptyPlaceholder === 'string') {
      return (
        <Typography textAlign="center" my={12}>
          {emptyPlaceholder}
        </Typography>
      );
    }

    return <>{emptyPlaceholder}</>;
  }
);
